import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * State and actions
 */

type State = {
  page: number,
  pageCount: number,
  sortField: string,
  sort: "asc" | "desc",
  rowsPerPage: number,
  totalItems: number,
};

type Action = {
  setPage: (p: number | ((p: number) => number)) => void,
  setPageCount: (p: number | ((p: number) => number)) => void,
  setRowsPerPage: (p: number | ((p: number) => number)) => void,
  setTotalItems: (p: number | ((p: number) => number)) => void,
};

/**
 * usePagination
 */

export const useFuncionariosListaPagination = create<State & Action>((set) => ({
  page: 1,
  pageCount: 0,
  rowsPerPage: 100,
  totalItems: 0,
  sortField: "",
  sort: "asc",
  setPage: (p) => typeof p === 'function'
    ? set((s) => ({ page: p(s.page) }))
    : set(() => ({ page: p })),
  setPageCount: (p) => typeof p === 'function'
    ? set((s) => ({ pageCount: p(s.pageCount) }))
    : set(() => ({ pageCount: p })),
  setRowsPerPage: (rpp) => typeof rpp === 'function'
    ? set((s) => ({ rowsPerPage: rpp(s.rowsPerPage) }))
    : set(() => ({ rowsPerPage: rpp })),
  setTotalItems: (ti) => typeof ti === 'function'
    ? set((s) => ({ totalItems: ti(s.totalItems) }))
    : set(() => ({ totalItems: ti })),
}));